<template>
    <div id="debugmenupage">
        <div class="leftcolumn">
            <table
                border="0"
                v-if="configVariables"
            >
                <tbody class="config-variables">
                    <tr>
                        <th>
                            {{ trans('pages.debug_menu.config_variables.url') }}
                        </th>
                        <td>{{ configVariables['URL'] || '?' }}</td>
                    </tr>
                    <tr>
                        <th>
                            {{
                                trans(
                                    'pages.debug_menu.config_variables.prosite_url'
                                )
                            }}
                        </th>
                        <td>{{ configVariables['PROSITE_URL'] || '?' }}</td>
                    </tr>
                    <tr>
                        <th>
                            {{
                                trans(
                                    'pages.debug_menu.config_variables.erp_db_host'
                                )
                            }}
                        </th>
                        <td>{{ configVariables['ERPDBHOST'] || '?' }}</td>
                    </tr>
                    <tr>
                        <th>
                            {{
                                trans(
                                    'pages.debug_menu.config_variables.aws_s3_bucket'
                                )
                            }}
                        </th>
                        <td>{{ configVariables['AWS_S3_BUCKET'] || '?' }}</td>
                    </tr>
                    <tr>
                        <th>
                            {{
                                trans(
                                    'pages.debug_menu.config_variables.frontend_version'
                                )
                            }}
                        </th>
                        <td>{{ frontEndVersion }}</td>
                    </tr>
                    <tr>
                        <th>
                            {{
                                trans(
                                    'pages.debug_menu.config_variables.backend_version'
                                )
                            }}
                        </th>
                        <td>{{ configVariables['BACKEND_VERSION'] || '?' }}</td>
                    </tr>
                </tbody>
                <tbody class="environment-variables">
                    <tr
                        v-for="(
                            value, key
                        ) in configVariables.environmentVariables"
                        :key="key"
                    >
                        <th>
                            {{ key.charAt(0).toUpperCase() + key.slice(1) }}
                        </th>
                        <td>{{ value }}</td>
                    </tr>
                </tbody>
            </table>

            <div class="grid grid-cols-12 items-stretch gap-8 mt-10">
                <div
                    class="menuitem"
                    @click="$router.push('/debugsawlines')"
                >
                    <h2>
                        {{ trans('pages.debug_menu.menu_items.saw_lines') }}
                    </h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-wrench fa-5x" />
                    </div>
                </div>
                <div
                    class="menuitem"
                    @click="$router.push('/debugcnc')"
                >
                    <h2>{{ trans('pages.debug_menu.menu_items.cnc') }}</h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-sliders fa-5x" />
                    </div>
                </div>
                <div
                    class="menuitem"
                    @click="$router.push('/debugproductdescriptions')"
                >
                    <h2>
                        {{
                            trans(
                                'pages.debug_menu.menu_items.product_descriptions'
                            )
                        }}
                    </h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-wrench fa-5x" />
                    </div>
                </div>
                <div
                    class="menuitem"
                    @click="$router.push('/debugsawlineerrors')"
                >
                    <h2>
                        {{
                            trans('pages.debug_menu.menu_items.saw_line_errors')
                        }}
                    </h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-wrench fa-5x" />
                    </div>
                </div>
                <div
                    class="menuitem"
                    @click="$router.push('/debugactivateprofile')"
                >
                    <h2>
                        {{
                            trans(
                                'pages.debug_menu.menu_items.activate_article'
                            )
                        }}
                    </h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-wrench fa-5x" />
                    </div>
                </div>
                <div
                    class="menuitem"
                    @click="startScanning"
                >
                    <h2>
                        {{
                            trans(
                                'pages.debug_menu.menu_items.test_barcode_scanner'
                            )
                        }}
                    </h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-wrench fa-5x"></i>
                    </div>
                </div>
                <div
                    class="menuitem"
                    @click="$router.push('/activatearticles/')"
                >
                    <h2>
                        {{
                            trans(
                                'pages.debug_menu.menu_items.reactivate_multiple_articles'
                            )
                        }}
                    </h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-wrench fa-5x"></i>
                    </div>
                </div>
                <div
                    class="menuitem"
                    @click="clearTranslationsCache()"
                >
                    <h2>
                        {{
                            trans(
                                'pages.debug_menu.menu_items.clear_translations_cache'
                            )
                        }}
                    </h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-trash fa-5x"></i>
                    </div>
                </div>
                <div
                    class="menuitem"
                    @click="$router.push('/flows-and-statuses')"
                >
                    <h2>
                        {{
                            trans(
                                'pages.debug_menu.menu_items.flows_and_statuses'
                            )
                        }}
                    </h2>
                    <div class="menuimgdiv">
                        <i class="fa fa-project-diagram fa-5x"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import settingsApi from '../api/settings';
import localization from '../mixins/localization';
import localizationApi from '../api/localization';
import { showInfoMessage, showErrorMessage } from '../dialogs';

export default {
    mixins: [localization],
    data() {
        return {
            configVariables: null,
        };
    },
    methods: {
        startScanning() {
            this.$bus.$emit('qr_scanner.start', 'debug', {
                singleScan: true,
            });
        },
        clearTranslationsCache() {
            localizationApi
                .clearCache()
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.debug_menu.messages.translations_cache_cleared'
                        )
                    );
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans(
                            'pages.debug_menu.messages.translations_cache_clear_failed'
                        )
                    );
                });
        },
    },
    computed: {
        frontEndVersion() {
            return Config.version || '?';
        },
    },
    mounted() {
        settingsApi.fetchDebugMenuInfo().then((request) => {
            this.configVariables = request.data.data;
        });
    },
};
</script>
